import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { playerSearchOrigin } from "@/lib/player-navigation";
import { legacyActionDestination } from "@/components/player-actions/action-model";

export function BansRoute() {
  const [params] = useSearchParams();
  const location = useLocation();
  const id = params.get("playfabId");
  return <Navigate replace to={legacyActionDestination("bans", id)} state={{ origin: playerSearchOrigin(location.state) }} />;
}
